import { negotiateAudioMime, type AudioMimeEnv } from "@speakai/common/src/recorder/core/negotiation/audio-mime";
import { negotiateScreenMime } from "@speakai/common/src/recorder/core/negotiation/screen-mime";
import { negotiateVideoMime } from "@speakai/common/src/recorder/core/negotiation/video-mime";
import { isSafariUserAgent } from "./screen-capture-support";

function browserMimeEnv(): AudioMimeEnv {
  if (typeof MediaRecorder === "undefined") return {};
  const ua = navigator.userAgent;
  return {
    isTypeSupported: (mimeType) => MediaRecorder.isTypeSupported(mimeType),
    isFirefox: /firefox/i.test(ua),
    isSafari: isSafariUserAgent(ua),
  };
}

export function getSupportedAudioMime(): string {
  return negotiateAudioMime(browserMimeEnv());
}

export function getVideoMimeType(): string {
  return negotiateVideoMime(browserMimeEnv());
}

export function getSupportedScreenMime(): string {
  return negotiateScreenMime(browserMimeEnv());
}
